export default __webpack_public_path__ + "static/media/blob_right.0d1b6efe.svg";